import React, { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { jwtDecode } from 'jwt-decode';
import { API_BASE_URL } from '../../config'; // Adjust path to your config
import { toast } from 'react-toastify';
import Loader from '../../components/loader2'; // Adjusted path to existing Loader

const ConnectSponsorHandler = () => {
  const { businessUserId } = useParams(); // Matches /connect-sponsor/:businessUserId
  const navigate = useNavigate();

  useEffect(() => {

    const userType = localStorage.getItem('userType');
    
    const initiateChat = async () => {
      try {
        const token = localStorage.getItem('token');
        

        if (!token) {
          // Should not happen if Login logic worked, but safety net:
          navigate(`/login?returnUrl=${encodeURIComponent(window.location.pathname)}`);
          return;
        }

        const decoded = jwtDecode(token);
        const currentUserId = decoded.nameid; // or however your token stores ID

        // LOGIC FROM handleMessageClickConcise
        let url = "";
        const targetBusinessId = parseInt(businessUserId);

        if (userType === "Home") {
          // Home user talking to Business (targetBusinessId)
          // senderBusinessUserId = The business we want to talk to
          // homeUserId = Me
          url = `senderBusinessUserId=${targetBusinessId}&homeUserId=${currentUserId}`;
        } else {
          // Business talking to Business
          // senderBusinessUserId = Me (currentUserId)
          // receiverBusinessUserId = The business we want to talk to
          url = `senderBusinessUserId=${currentUserId}&receiverBusinessUserId=${targetBusinessId}`;
        }

        console.log(`Initiating Deep Link Chat: ${url}`);

        const response = await axios.get(`${API_BASE_URL}/api/Chat/NewConversation?${url}`, {
            headers: { Authorization: `Bearer ${token}` }
        });

        const { conversationId } = response.data;
        
        // Redirect to the actual message UI
        const path = userType === "Home"
          ? `/home_messages?conversationId=${conversationId}`
          : `/business_messages?conversationId=${conversationId}`;

        // Use replace to ensure back button doesn't loop this logic
        navigate(path, { replace: true });

      } catch (error) {
        console.error("Deep link chat error:", error);
        toast.error("Could not initiate conversation. Please try again.");
        // Fallback redirect
        navigate(userType === "Home" ? '/newhome' : '/businessdash');
      }
    };

    initiateChat();
  }, [businessUserId, navigate]);

  return (
    <div style={{ height: '100vh', display: 'flex', flexDirection:'column', alignItems:'center', justifyContent:'center' }}>
       <Loader />
       <h3 style={{marginTop: '20px', color: '#666'}}>Connecting you to the sponsor...</h3>
    </div>
  );
};

export default ConnectSponsorHandler;
